import { useState } from "react";
import "../assets/css/ButtonLive.css";
import { json } from "zod";

export default function ButtonLive({ liveIsActive }) {
  const [rodando, setRodando] = useState(liveIsActive.current);

  const handleClick = () => {
    const novoEstado = !rodando;
    liveIsActive.current = novoEstado;
    setRodando(novoEstado);
    localStorage.setItem("liveIsActive", JSON.stringify(novoEstado));
  };

  return (
    <div className="player-controls">

    { !rodando &&
    <div className="xxx456" style={{height: "fit-content"}}>
      <span id="status-msg" class="player-status is-visible">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
          <path d="M6 5h4v14H6zM14 5h4v14h-4z" />
        </svg>
        Mercados pausados
      </span>
      </div>}
      <button
        className={`ButtonLive ${rodando ? "running" : ""}`}
        onClick={handleClick}
        aria-label={rodando ? "Pausar" : "Iniciar"}
      >
        {rodando ? (
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M6 5h4v14H6zM14 5h4v14h-4z" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M8 5v14l11-7z" />
          </svg>
        )}
        <span>{rodando ? "PAUSAR" : "INICIAR"}</span>
      </button>
    </div>
  );
}
